import CryptoJS from "crypto-js";
import { cryptoSecretKey } from "./Constant";

const key = CryptoJS.enc.Utf8.parse(cryptoSecretKey);

export const encryptId = (id) => {
  const encrypted = CryptoJS.AES.encrypt(id, key, {
    mode: CryptoJS.mode.ECB,
  }).toString();
  return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); // URL-safe
};

export const decryptId = (encryptedId) => {
  const restored = encryptedId.replace(/-/g, "+").replace(/_/g, "/"); // Convert back
  return CryptoJS.AES.decrypt(restored, key, {
    mode: CryptoJS.mode.ECB,
  }).toString(CryptoJS.enc.Utf8);
};

// // Helper: Encode hex string to URL-safe Base64
// function hexToBase64(hexStr) {
//     const hexArray = hexStr?.match(/.{1,2}/g) || [];
//     const byteArray = new Uint8Array(hexArray.map(byte => parseInt(byte, 16)));
//     const binaryString = Array.from(byteArray).map(byte => String.fromCharCode(byte)).join('');
//     return btoa(binaryString)
//         .replace(/\+/g, '-')
//         .replace(/\//g, '_')
//         .replace(/=+$/, '');
// }

// function isValidBase64(str) {
//     return /^[A-Za-z0-9_-]+$/.test(str) && str?.length % 4 !== 1;
// }

// function base64ToHex(base64Str) {
//     if (!isValidBase64(base64Str)) {
//         throw new Error("Invalid Base64 input");
//     }

//     let padded = base64Str?.replace(/-/g, '+')?.replace(/_/g, '/');
//     padded += '='.repeat((4 - (padded?.length % 4)) % 4); // Ensure correct padding

//     try {
//         const binaryString = atob(padded);
//         return Array.from(binaryString)
//             .map(byte => byte.charCodeAt(0).toString(16).padStart(2, '0'))
//             .join('');
//     } catch (error) {
//         console.error("Failed to decode Base64:", base64Str);
//         throw error;
//     }
// }

// function isValidUUID(uuid) {
//     return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(uuid);
// }

// export function encryptId(uuid) {
//     if (!isValidUUID(uuid)) {
//         throw new Error("Invalid UUID format");
//     }
//     const hex = uuid.replace(/-/g, '');
//     return hexToBase64(hex);
// }

// // Decode Base64 back to UUID
// export function decryptId(encodedId) {
//     const hex = base64ToHex(encodedId);
//     // Reconstruct UUID format (8-4-4-4-12)
//     return `${hex.substring(0, 8)}-${hex.substring(8, 12)}-${hex.substring(12, 16)}-${hex.substring(16, 20)}-${hex.substring(20)}`;
// }
